import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface PublicRouteProps {
  children: JSX.Element;
  allowUnauthenticated?: boolean; // NEW: Allow unauthenticated access
  redirectPath?: string; // NEW: Custom redirect path
}

export default function PublicRoute(props: PublicRouteProps): JSX.Element {
  const { isAuthenticated } = useAuth0();
  const { allowUnauthenticated = false, redirectPath = '/', children } = props;

  // If authenticated and should redirect, navigate away
  if (isAuthenticated && !allowUnauthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // If not authenticated but require auth, show children anyway
  // This allows true public access for signup
  return children;
}
